import React from "react";
import { Route } from "react-router-dom";
import { leaves } from "~/constants";
import { WebflowReplace } from "./WebflowReplace";

export const WebflowRoutes = (
  <>
    <Route index element={<WebflowReplace />} />

    <Route path={leaves.clinics} element={<WebflowReplace />} />
    <Route path={leaves.howItWorks} element={<WebflowReplace />} />
    <Route path={leaves.about} element={<WebflowReplace />} />
    <Route path={leaves.philosophy} element={<WebflowReplace />} />
    <Route path={leaves.careers} element={<WebflowReplace />} />
  </>
);
